import { LOADING, ActionSource, asAction } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { evalSummary, firstImageURL, makeDropImageHandler } from "common/components/portable-renderers";
import GalleryItem from "../../ui/deprecated/GalleryItem";
import { loadedDefinedMap, asString } from "common/components/component-helpers";
import { definedMap } from "@glideapps/ts-necessities";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

export const GalleryItemMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[titleValue, subtitleValue, , fallbackInitials, onTap, onDropImage], [, , imageVP]] = useForceValueProducers(
        getValueProducers,
        force,
        ctx
    );
    if (titleValue === LOADING) {
        return env.renderProgress();
    }
    const { imageSource } = evalSummary(titleValue, subtitleValue, imageVP, force);
    let fallback: string | undefined;
    if (fallbackInitials === LOADING) {
        fallback = "";
    } else {
        fallback = definedMap(fallbackInitials, asString);
    }
    const onClick = loadedDefinedMap(onTap, o => () => asAction(o).run(ctx, env, ActionSource.GridItem));
    let src: string | undefined;
    if (imageSource !== undefined) {
        src = firstImageURL(imageSource, { thumbnail: false });
    }
    return (
        <GalleryItem
            src={src}
            onClick={onClick}
            onDropImage={makeDropImageHandler(env, onDropImage, ActionSource.GalleryItem)}
            fallback={fallback}
        />
    );
};
